import $ from 'jquery';

const Toggler = (el) => {
    // el is the toggler
    // toggle is the element with state update
    const toggle = document.getElementById(el.dataset.toggle);
    // control is the element that the toggle controls
    const control = document.getElementById(el.getAttribute('aria-controls'));
    const $control = $(control);

    // For custom data layer events, pass JSON from backend
    const dataLayerOpen = el.getAttribute('data-tracking-open');
    const dataLayerClose = el.getAttribute('data-tracking-close');

    const triggerTracking = (push) => {
        if(push && window.dataLayer) {
            window.dataLayer.push(JSON.parse(push));
        }
    };

    el.addEventListener('click', () => {
        const isOpen = el.classList.contains('js-state-toggle--active');
        if(isOpen) {
            if($control && $control.length) {
                $control.hide();
            }

            toggle.classList.remove('js-state-toggle--open');
            el.classList.remove('js-state-toggle--active');
            el.setAttribute('aria-expanded', 'false');

            if(control && control.length) {
                control.setAttribute('aria-hidden', 'true');
            }

            triggerTracking(dataLayerClose);
        } else {
            if($control && $control.length) {
                $control.show();
            }

            toggle.classList.add('js-state-toggle--open');
            el.classList.add('js-state-toggle--active');
            el.setAttribute('aria-expanded', 'true');

            if(control && control.length) {
                control.setAttribute('aria-hidden', 'false');
            }

            triggerTracking(dataLayerOpen);
        }
    });
};


export default Toggler;